import { ColorDynamic } from '@superdispatch/ui';
import styled from 'styled-components';

const Container = styled.div`
  padding: 16px;
  border-radius: 4px;
  background-color: ${ColorDynamic.Yellow50};
`;

export function LoadAlertDisabledWarning() {
  return (
    <Container aria-label="load alert warning">
      Notifications for all Load Alerts have been disabled. Enable notifications
      to get notified about loads matching your preferences.
    </Container>
  );
}

export function AllNotificationDisabledWarning() {
  return (
    <Container aria-label="all notification warning">
      Super Loadboard notifications have been disabled. Enable notifications to
      get notified about loads matching your preferences.
    </Container>
  );
}
